import { css } from 'styled-components'
import { maxMq, minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'
import { Category, getColor } from '../../utils/news'

const card = css`
  ${maxMq('MD')} {
    display: grid;
    gap: 10px 14px;
    grid-template-columns: 104px 1fr;
    grid-template-rows: auto auto;
  }
`

const wrapImage = css`
  background-color: ${variables.LIGHT_GRAY};
  display: block;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  width: 100%;
  
  ${minMq('MD')}  {
    margin-bottom: 28px;
    height: auto;
    aspect-ratio: 4 / 3;
  }

  ${maxMq('MD')} {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    height: 78px;
  }
`

const image = css`
  height: 100%;
  object-fit: contain;
  width: 100%;
`

const info = css`
  ${minMq('MD')} {
    margin-bottom: 16px;
    display: flex;
    gap: 12px;
  }

  ${maxMq('MD')} {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }
`

const categories = css`
  display: flex;
  gap: 8px;

  ${maxMq('MD')} {
    flex-wrap: wrap;
    margin-bottom: 8px;
  }
`

const category = (val: Category) => {
  return css`
    background-color: ${getColor(val)};
    border-radius: 4px;
    color: ${variables.WHITE};
    display: grid;
    font-size: 1.4rem;
    line-height: 24px;
    place-content: center;
    width: 60px;
  `
}

const date = css`
  color: ${variables.GRAY};
  font-family: 'Lato', 'Noto Sans JP', sans-serif;
`

const title = css`
  ${maxMq('MD')} {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
  }
`

export const style = {
  card,
  wrapImage,
  image,
  info,
  categories,
  category,
  date,
  title,
}